{
  "__review_clinicalData": "Backend/clinician-authored API data (allergen/medication/problem/provider/result names, values, units, ranges, comments, message bodies) — Phase 9, do not translate",
  "enums": {
    "appointmentStatus": {
      "scheduled": "திட்டமிடப்பட்டது",
      "confirmed": "உறுதிப்படுத்தப்பட்டது",
      "completed": "முடிக்கப்பட்டது",
      "cancelled": "ரத்து செய்யப்பட்டது",
      "no-show": "வரவில்லை",
      "checked-in": "பதிவு செய்யப்பட்டது"
    },
    "resultStatus": {
      "final": "இறுதி",
      "preliminary": "முதற்கட்ட",
      "corrected": "திருத்தப்பட்டது"
    },
    "allergySeverity": {
      "severe": "கடுமையான",
      "high": "உயர்",
      "moderate": "மிதமான"
    },
    "nationalIdType": {
      "NRIC": "NRIC (சிங்கப்பூர்)",
      "HKID": "HKID (ஹாங்காங்)",
      "MyKad": "MyKad (மலேசியா)",
      "Aadhaar": "ஆதார் (இந்தியா)",
      "KTP": "KTP (இந்தோனேசியா)",
      "Passport": "கடவுச்சீட்டு"
    },
    "messageSenderType": {
      "provider": "வழங்குநர்",
      "patient": "நோயாளர்"
    }
  },
  "form": {
    "validation": {
      "passwordMismatch": "கடவுச்சொற்கள் பொருந்தவில்லை",
      "passwordMinLength": "கடவுச்சொல் குறைந்தது 8 எழுத்துகள் இருக்க வேண்டும்"
    }
  },
  "labels": {
    "abnormal": "அசாதாரணம்"
  },
  "pages": {
    "layout": {
      "nav": {
        "myHealth": "என் ஆரோக்கியம்",
        "results": "முடிவுகள்",
        "appointments": "சந்திப்புகள்",
        "messages": "செய்திகள்",
        "forms": "படிவங்கள்"
      },
      "signOut": "வெளியேறு",
      "signOutAria": "வெளியேறு",
      "navAria": "போர்ட்டல் வழிசெலுத்தல்",
      "footer": "VynaEMR நோயாளர் போர்ட்டல் — FLOSTEL Healthcare IT"
    },
    "login": {
      "subtitle": "நோயாளர் போர்ட்டல்",
      "labels": {
        "email": "மின்னஞ்சல்",
        "password": "கடவுச்சொல்"
      },
      "placeholders": {
        "email": "you@example.com",
        "password": "உங்கள் கடவுச்சொல்லை உள்ளிடவும்"
      },
      "button": {
        "signIn": "உள்நுழைய",
        "signingIn": "உள்நுழைகிறது..."
      },
      "toast": {
        "welcome": "மீண்டும் வரவேற்கிறோம்!",
        "invalid": "தவறான மின்னஞ்சல் அல்லது கடவுச்சொல்"
      },
      "links": {
        "noAccount": "கணக்கு இல்லையா?",
        "register": "பதிவு செய்க"
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "காலை வணக்கம்",
        "afternoon": "மதிய வணக்கம்",
        "evening": "மாலை வணக்கம்",
        "fallbackName": "நண்பரே"
      },
      "subtitle": "உங்கள் ஆரோக்கியச் சுருக்கம் கீழே உள்ளது.",
      "error": "உங்கள் ஆரோக்கியச் சுருக்கத்தை ஏற்ற முடியவில்லை. பின்னர் மீண்டும் முயற்சிக்கவும்.",
      "demographics": {
        "ageLabel": "வயது {{age}}",
        "bloodTypeLabel": "ரத்த வகை: {{bloodType}}"
      },
      "quickLinks": {
        "results": "முடிவுகள்",
        "appointments": "சந்திப்புகள்",
        "messages": "செய்திகள்",
        "forms": "படிவங்கள்"
      },
      "sections": {
        "allergies": "ஒவ்வாமைகள்",
        "activeMedications": "தற்போதைய மருந்துகள்",
        "activeProblems": "தற்போதைய பிரச்சினைகள்",
        "upcomingAppointments": "வரவிருக்கும் சந்திப்புகள்",
        "recentResults": "சமீபத்திய முடிவுகள்",
        "immunizations": "தடுப்பூசி பதிவு",
        "emergencyContact": "அவசரத் தொடர்பு"
      },
      "states": {
        "noAllergies": "பதிவில் ஒவ்வாமைகள் இல்லை.",
        "noMedications": "தற்போதைய மருந்துகள் இல்லை.",
        "noAppointments": "வரவிருக்கும் சந்திப்புகள் இல்லை.",
        "noResults": "சமீபத்திய முடிவுகள் இல்லை."
      },
      "moreCount": "+{{count}} மேலும்",
      "sinceDate": "{{date}} முதல்",
      "doseNumber": "மருந்தளவு {{number}}",
      "viewAll": "அனைத்தையும் காண்க",
      "providerTBD": "வழங்குநர் நிர்ணயிக்கப்படவில்லை"
    },
    "register": {
      "subtitle": "உங்கள் கணக்கை உருவாக்கவும்",
      "labels": {
        "fullName": "முழுப் பெயர்",
        "email": "மின்னஞ்சல்",
        "dateOfBirth": "பிறந்த தேதி",
        "phone": "தொலைபேசி",
        "mrn": "MRN (மருத்துவப் பதிவு எண்)",
        "idType": "அடையாள வகை",
        "idNumber": "அடையாள எண்",
        "password": "கடவுச்சொல்",
        "confirmPassword": "கடவுச்சொல்லை உறுதிப்படுத்தவும்"
      },
      "placeholders": {
        "fullName": "உங்கள் முழுப் பெயர்",
        "email": "you@example.com",
        "phone": "+65 9123 4567",
        "mrn": "e.g. P0000000001",
        "idNumber": "உங்கள் அடையாள எண்",
        "password": "குறைந்தது 8 எழுத்துகள்",
        "confirmPassword": "உங்கள் கடவுச்சொல்லை மீண்டும் உள்ளிடவும்",
        "selectIdType": "தேர்ந்தெடுக்கவும்..."
      },
      "mrnHint": "உங்கள் கணக்கை மருத்துவப் பதிவுடன் இணைக்க, உங்கள் MRN அல்லது தேசிய அடையாள எண்ணை வழங்கவும்.",
      "button": {
        "createAccount": "கணக்கை உருவாக்கு",
        "creatingAccount": "கணக்கை உருவாக்குகிறது..."
      },
      "toast": {
        "success": "பதிவு வெற்றியடைந்தது. தயவுசெய்து உள்நுழையவும்.",
        "failure": "பதிவு தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்."
      },
      "links": {
        "haveAccount": "ஏற்கனவே கணக்கு உள்ளதா?",
        "signIn": "உள்நுழைய"
      },
      "aria": {
        "dateOfBirth": "பிறந்த தேதி"
      }
    },
    "appointments": {
      "title": "சந்திப்புகள்",
      "subtitle": "உங்கள் சந்திப்புகளைக் காண்பித்து நிர்வகிக்கவும்",
      "error": "சந்திப்புகளை ஏற்ற முடியவில்லை. சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்.",
      "sections": {
        "upcoming": "வரவிருப்பவை",
        "past": "கடந்தவை"
      },
      "states": {
        "noUpcoming": "வரவிருக்கும் சந்திப்புகள் இல்லை.",
        "noPast": "கடந்த சந்திப்புகள் இல்லை."
      },
      "reasonLabel": "காரணம்: {{reason}}",
      "instructionsLabel": "வழிமுறைகள்: {{instructions}}",
      "durationMinutes": "{{minutes}} நிமிடம்",
      "actions": {
        "cancel": "ரத்து செய்",
        "confirmCancel": "உறுதிசெய்",
        "cancelling": "ரத்து செய்யப்படுகிறது...",
        "keep": "தொடரட்டும்"
      },
      "toast": {
        "cancelSubmitted": "ரத்து செய்யும் கோரிக்கை சமர்ப்பிக்கப்பட்டது. உங்கள் பராமரிப்புக் குழு உறுதிப்படுத்தும்.",
        "cancelFailed": "சந்திப்பை ரத்து செய்ய முடியவில்லை. தயவுசெய்து அலுவலகத்திற்கு அழைக்கவும்."
      }
    },
    "results": {
      "title": "எனது முடிவுகள்",
      "subtitle": "உங்கள் ஆய்வக மற்றும் படிமவியல் முடிவுகளைப் பார்க்கவும்",
      "error": "முடிவுகளை ஏற்ற முடியவில்லை. சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்.",
      "referenceRange": "(குறிப்பு: {{range}})",
      "states": {
        "noResults": "முடிவுகள் எதுவும் இல்லை."
      }
    },
    "messages": {
      "title": "செய்திகள்",
      "subtitle": "உங்கள் பராமரிப்புக் குழுவுடன் தொடர்பு கொள்ளுங்கள்",
      "error": "செய்திகளை ஏற்ற முடியவில்லை. சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்.",
      "fromSender": "{{name}} இடமிருந்து",
      "labels": {
        "subject": "தலைப்பு",
        "message": "செய்தி",
        "reply": "பதில்"
      },
      "placeholders": {
        "subject": "செய்தியின் தலைப்பு",
        "message": "உங்கள் செய்தியைத் தட்டச்சு செய்க...",
        "reply": "உங்கள் பதிலைத் தட்டச்சு செய்க..."
      },
      "actions": {
        "newMessage": "புதிய செய்தி",
        "back": "செய்திகளுக்குத் திரும்பு",
        "sendMessage": "செய்தியை அனுப்பு",
        "sendReply": "பதிலை அனுப்பு",
        "sending": "அனுப்புகிறது..."
      },
      "states": {
        "noMessages": "இதுவரை செய்திகள் எதுவும் இல்லை."
      },
      "thread": {
        "fromSenderWithType": "{{name}} ({{type}}) இடமிருந்து"
      },
      "compose": {
        "title": "புதிய செய்தி",
        "subtitle": "உங்கள் செய்தி உங்கள் பராமரிப்புக் குழுவுக்கு அனுப்பப்படும்."
      },
      "toast": {
        "sent": "செய்தி அனுப்பப்பட்டது",
        "sendFailed": "செய்தியை அனுப்ப முடியவில்லை"
      }
    },
    "forms": {
      "title": "படிவங்கள்",
      "subtitle": "தேவையான படிவங்கள் மற்றும் வினாத்தாள்களை நிரப்பவும்",
      "error": "படிவங்களை ஏற்ற முடியவில்லை. பின்னர் மீண்டும் முயற்சிக்கவும்.",
      "sections": {
        "pending": "நிலுவையில்",
        "completed": "முடிந்தது"
      },
      "labels": {
        "required": "தேவை"
      },
      "placeholders": {
        "select": "தேர்ந்தெடுக்கவும்..."
      },
      "actions": {
        "fillOut": "நிரப்பவும்",
        "back": "படிவங்களுக்குத் திரும்பு",
        "submit": "படிவத்தைச் சமர்ப்பிக்கவும்",
        "submitting": "சமர்ப்பிக்கப்படுகிறது..."
      },
      "states": {
        "noPending": "நிலுவையில் உள்ள படிவங்கள் எதுவும் இல்லை.",
        "noCompleted": "முடிந்த படிவங்கள் எதுவும் இல்லை.",
        "noFields": "இந்தப் படிவத்தில் நிரப்ப வேண்டிய புலங்கள் இல்லை."
      },
      "toast": {
        "submitted": "படிவம் வெற்றிகரமாகச் சமர்ப்பிக்கப்பட்டது",
        "submitFailed": "படிவத்தைச் சமர்ப்பிக்க முடியவில்லை"
      }
    }
  }
}
